export default "__VITE_ASSET__D6lqpXdI__"